import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import { getTripCalendarTheme } from '../getTripCalendarTheme';

import type { EventBadgesProps } from './EventBadgesProps';

type EventBadgeProps = {
  styleOverrides?: React.CSSProperties;
  children: React.ReactNode;
  tooltipContent?: string;
  dataTestId?: string;
} & EventBadgesProps;

export function EventBadge({
  styleOverrides,
  trip,
  type,
  children,
  tooltipContent = '',
  dataTestId,
}: EventBadgeProps) {
  const theme = getTripCalendarTheme(trip, type);

  return (
    <div
      style={{
        backgroundColor: theme.bg,
        color: theme.text,
        borderColor: theme.border,
        borderWidth: '1px',
        ...styleOverrides,
      }}
      className="rounded-full p-0.5 text-xs leading-none"
      data-testid={dataTestId}
    >
      <SimpleTooltip content={tooltipContent} trigger={<div>{children}</div>} />
    </div>
  );
}
